import React, { useState, useEffect, useRef } from 'react';

function AutocompleteInput({ id, value, onChange, suggestions = [], placeholder, type = 'text', required, minChars = 3 }) {
    const [showDropdown, setShowDropdown] = useState(false);
    const [filtered, setFiltered] = useState([]);
    const [focused, setFocused] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!focused) return;
        if (value.length >= minChars) {
            const matches = [...new Set(
                value
                    ? suggestions.filter(s => s && s.toLowerCase().includes(value.toLowerCase()))
                    : suggestions
            )];
            setFiltered(matches);
            setShowDropdown(matches.length > 0);
        } else {
            setShowDropdown(false);
        }
    }, [value, suggestions, minChars, focused]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setShowDropdown(false);
                setFocused(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (val) => {
        onChange({ target: { id, value: val } });
        setShowDropdown(false);
        setFocused(false);
    };

    return (
        <div ref={containerRef} style={{ position: 'relative' }}>
            <input
                type={type}
                className="form-control"
                id={id}
                value={value}
                onChange={onChange}
                onFocus={() => {
                    setFocused(true);
                    if (value.length >= minChars) {
                        const matches = [...new Set(
                            value
                                ? suggestions.filter(s => s && s.toLowerCase().includes(value.toLowerCase()))
                                : suggestions
                        )];
                        if (matches.length > 0) { setFiltered(matches); setShowDropdown(true); }
                    }
                }}
                placeholder={placeholder}
                required={required}
                autoComplete="off"
            />
            {showDropdown && (
                <ul
                    className="list-group shadow-sm"
                    style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 9999,
                        maxHeight: '180px',
                        overflowY: 'auto',
                        border: '1px solid #ced4da',
                        borderTop: 'none',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    {filtered.map((item, i) => (
                        <li
                            key={i}
                            className="list-group-item list-group-item-action py-2 px-3"
                            style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                            onMouseDown={() => handleSelect(item)}
                        >
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default AutocompleteInput;
